import { customTwMerge as twMerge } from "@/helpers/customTwMerge";
import React, { useState } from "react";

const ReadMore = ({ text = "", maxLength = 100, className = "" }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    // todo: remove important
    <div
      className={twMerge(
        "text-content-secondary text-xs md:!text-sm",
        className,
      )}
    >
      {isExpanded
        ? text
        : `${text.slice(0, maxLength)} ${text.length > maxLength ? "..." : ""}`}
      {text.length > maxLength && (
        <button
          onClick={toggleReadMore}
          className={twMerge("underline", isExpanded && "ml-2")}
        >
          {isExpanded ? "Read less" : "Read more"}
        </button>
      )}
    </div>
  );
};

export default ReadMore;
